export interface TeamMetricResult {
  value: number;
  displayValue: string;
  subtitle: string;
  previousValue?: number;
  percentageChange?: number;
  comparisonPeriod?: string;
}
export type MetricType = 'deploymentFrequency' | 'changeFailRate' | 'prTime' | 'pbiTimeByColumn' | 'genericPositiveIsGood' | 'genericNegativeIsGood';

export type CalculationLogic = 'Median' | 'Mean' | 'IQR';

export const DEFAULT_CALCULATION_LOGIC: CalculationLogic = 'Median';

export interface ChangeFailRateResult extends TeamMetricResult {
  totalReleases: number;
  failedReleases: number;
  period: string;
}

export interface DeploymentFrequencyResult extends TeamMetricResult {
  totalDeployments: number;
  averageDeploymentsPerDay: number;
  period: string;
}

export interface PrTimeToFirstReviewResult extends TeamMetricResult {
  q1DurationHours?: number;
  q3DurationHours?: number;
  totalPrsConsidered: number;
  totalPrsFetched: number;
  period: string;
  calculationMethodUsed?: CalculationLogic;
  rawDurationsHours?: number[]; 
  startDateIso?: string; 
  endDateIso?: string;
  previousPeriodDataForRecalc?: {
    rawDurationsHours: number[];
    totalPrsConsidered: number;
    totalPrsFetched: number;
    startDateIso: string;
    endDateIso: string;
  };
}

export interface PbiTimeByColumnResult extends TeamMetricResult {
  columns: { column: string; time: number; percentage: number }[];
  totalPbis: number;
  allColumnsWithData?: string[];
}
